import { render, staticRenderFns } from "./magiczoom.vue?vue&type=template&id=454307aa"
import script from "./magiczoom.vue?vue&type=script&lang=js"
export * from "./magiczoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports